import React, { useContext, useState } from 'react';
import { useGetDta } from '../../hooks/useGetDta';
import Table from '../Table';
import { headTbl } from '../../data/tables';
import classNames from 'classnames';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ModOlts from './ModOlts';
import EditOltM from './EditOltM';
import { AuthContext } from '../../auth/AuthContext';
import Confirmation from '../ui/Confirmation';
import LoadinSpin from '../ui/LoadinSpin';
import { checkAccess } from '../../helpers/details';

const TblOlts = () => {
    const { loading, data, getInfo } = useGetDta(`fibra/olts`);
    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Olts', auth.accesos);
    const { olt_add, olt_edit, olt_del, olt_det, olt_ports } = permisos.functions;
    const [modal, setModal] = useState(false);
    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false);
    const [olt, setOlt] = useState();
    const [info, setInfo] = useState({});

    const [className, setClassName] = useState(null);
    const [scroll, setScroll] = useState(null);
    const temColumn = ({ row }) => {
        return (
            <span>
                {row.original.tem} <i className="mdi mdi-thermometer" />
            </span>
        );
    };
    const StatusColumn = ({ row }) => {
        return (
            <>
                <span
                    className={classNames('badge', {
                        'bg-success': row.original.status === 'ONLINE',
                        'bg-danger': row.original.status === 'OFFLINE',
                    })}>
                    {row.original.status === 'ONLINE' ? 'ONLINE' : 'OFFLINE'}
                </span>
            </>
        );
    };
    const openEdit = (ol) => {
        setOlt(ol);
        setShow(!show);
    };
    const openModalWithSize = (id) => {
        setOlt(id);
        setClassName(null);
        setScroll(null);
        setModal(!modal);
    };
    if (loading) return <LoadinSpin />;

    const ActionColumn = ({ row }) => {
        return (
            <>
                <>
                    {olt_edit && (
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                            <i className="mdi mdi-pencil mdi-18px " onClick={() => openEdit(row.original)}></i>
                        </OverlayTrigger>
                    )}

                    {olt_det && (
                        <OverlayTrigger
                            placement="left"
                            overlay={<Tooltip id="overlay-example"> Ver detalles </Tooltip>}>
                            <i
                                className="mdi mdi-eye mdi-18px mx-2"
                                onClick={() => openModalWithSize(row.original)}></i>
                        </OverlayTrigger>
                    )}
                    {olt_del && (
                        <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example"> Borrar </Tooltip>}>
                            <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.id)}></i>
                        </OverlayTrigger>
                    )}
                </>
            </>
        );
    };
    const columns = [
        {
            Header: 'Olt',
            accessor: 'modelo',
            sort: true,
        },
        {
            Header: 'Nombre',
            accessor: 'nombre',
            sort: true,
        },

        {
            Header: 'Ip',
            accessor: 'ip',
            sort: true,
        },
        {
            Header: 'Estado',
            accessor: 'status',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'Temperatura',
            accessor: 'tem',
            sort: true,
            Cell: temColumn,
        },

        {
            Header: "Onus's",
            accessor: 'total',
            sort: true,
        },
        {
            Header: 'Mikrotik',
            accessor: 'mk',
            sort: true,
        },
        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    const dele = (id) => {
        setInfo({ id, type: 'OLT' });
        setShowd(true);
    };
    return (
        <div>
            <h4 className="header-title mb-2">Olts</h4>
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
                customButton={
                    olt_add && (
                        <Button type="button" onClick={() => openEdit({})}>
                            <b>+</b> Nuevo
                        </Button>
                    )
                }
            />
            <ModOlts
                show={modal}
                onHide={() => setModal(false)}
                dialogClassName={className}
                size="lg"
                scrollable={scroll}
                olt={olt}
                olports={olt_ports}
            />
            <EditOltM
                show={show}
                onHide={() => setShow(false)}
                dialogClassName={className}
                size="lg"
                callBk={getInfo}
                scrollable={scroll}
                olt={olt}
            />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};
export default TblOlts;
